import { render, staticRenderFns } from "./Statistics.vue?vue&type=template&id=a4c11c5e&scoped=true"
import script from "./Statistics.vue?vue&type=script&lang=js"
export * from "./Statistics.vue?vue&type=script&lang=js"
import style0 from "./Statistics.vue?vue&type=style&index=0&id=a4c11c5e&prod&lang=scss&scoped=true"
import style1 from "./Statistics.vue?vue&type=style&index=1&id=a4c11c5e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4c11c5e",
  null
  
)

export default component.exports